module.exports = __webpack_public_path__ + "static/media/malaysia-flag.cdd1c076.png";